export const da = () => import('./da.json');
export const en = () => import('./en.json');
export const fi = () => import('./fi.json');
export const nb = () => import('./nb.json');
export const sv = () => import('./sv.json');
export const nl = () => import('./nl.json');